import style from './ModalSampleView.module.css';

import closeSVG from 'assets/svg/close-01.svg';
import outSVG from 'assets/svg/sm_out-01.svg';
import intoSVG from 'assets/svg/sm_into-01.svg';
import children from 'assets/svg/create-children.svg';
import notification from 'assets/svg/notification.svg';

import { useEffect, useRef, useState } from 'react';
import Barcode from 'react-barcode';
import { getStorages } from 'services/storage.services';
import { deleteSample, getFileSample, moveSample } from 'services/sample.services';
import { getListPacks, getListUnits, getTypeSamples } from 'services/list.services';
import { getMappingCatalog } from 'services/catalog.services';
import moment from 'moment';
import { getFreePacks } from 'services/pucks.services';
import { address_server_short, COLORS, PUBLIC_ASSETS } from 'config';
import Progress from 'rsuite/Progress';
import FileSaver from 'file-saver';
import { getTypeSampleSourcesList } from 'services/typeSampleSource.services';
import classNames from 'classnames';
import ModalMoveComponent, {
  ModeCopy,
  ModeMove,
} from 'components/Widgets/Modal/ModalMoveComponent';
import PrintSizeModal from 'components/WorkRight/WorkRightCommon/WorkRightTable/printSizeModal';
import ModalDefreeze from '../ModalDefreeze/ModalDefreeze';
import ModalRestoreSample from '../ModalRestoreSample/ModalRestoreSample';
import ModalHistory from '../ModalHistory/ModalHistory';
import ModalCreateChildren from '../ModalCreateChildren/ModalCreateChildren';
import ModalTreeParent from '../ModalTreeParent/ModalTreeParent';
import ModalSetNotification from '../ModalSetNotification/ModalSetNotification';
import AddSampleSourceModal from 'components/WorkRight/WorkRightSamplesDir/SampleSources/forms/AddSampleSourceModal';
import { modalStore } from 'store/mobx/modal.store';
import { storageStore } from 'store/mobx/storage.store';
import useAlert from 'hooks/useAlert';

const ModalSampleView = (props) => {
  const { mode, sampleSourceStore, setSelectedTreeSample, storeContext } = props;

  const {
    selectedSample,
    getPath,
    clearSelectedSample,
    deleteSampleInPackById,
    loadTree,
    updateSelectedTreeNodePacks,
  } = storeContext;

  const { selectedEmptyCellForCopy } = storageStore;

  const rules = mode.rules ?? {};
  const blockRef = useRef(null);
  const { showAlert } = useAlert();

  const [modalMove, setModalMove] = useState(false);
  const [modalMoveMode, setModalMoveMode] = useState(ModeMove);
  const [treeLocation, setTreeLocation] = useState([]);
  const [types, setTypes] = useState([]);
  const [packs, setPacks] = useState([]);
  const [path, setPatch] = useState('');
  const [unitsList, setUnitsList] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState();
  const [patientDescriptions, setPatientDescriptions] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedPack, setSelectedPack] = useState();
  const [isOpenPrintModal, setIsOpenPrintModal] = useState(false);
  const [printItems, setPrintItems] = useState([]);
  const [defreezeModal, setDefreezeModal] = useState({ show: false, type: null });
  const [restoreModal, setRestoreModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [createChildrenModal, setCreateChildrenModal] = useState(false);
  const [treeParentModal, setTreeParentModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [sampleSourceModal, setSampleSourceModal] = useState(false);
  const [typesSampleSource, setTypesSampleSource] = useState([]);
  const [isEditSampleSourceSuccess, setIsEditSampleSourceSuccess] = useState(false);

  useEffect(() => {
    if (isEditSampleSourceSuccess) {
      onClose();
    }
  }, [isEditSampleSourceSuccess]);

  useEffect(() => {
    if (!selectedSample || !types.length) return;
    const found = types.find((i) => i.id === selectedSample.type);
    if (found) setSelectedType(found);
  }, [selectedSample?.type, types]);

  useEffect(() => {
    if (selectedSample === null) {
      modalStore.closeModal('sampleView');
    }
  }, [selectedSample]);

  useEffect(() => {
    if (!selectedSample?.storage) return;

    const loadPath = async () => {
      const res = await getPath(selectedSample.storage);
      setPatch(res);
    };
    loadPath();
  }, [selectedSample?.storage]);

  useEffect(() => {
    const loadPacksByStorageId = async () => {
      if (selectedSample?.storage === undefined || selectedSample?.storage === 0) {
        let freePacks = await getFreePacks();
        setPacks(freePacks);
      } else {
        let res = await getListPacks(selectedSample?.storage);
        setPacks(res);
      }
    };
    loadPacksByStorageId();
  }, [selectedSample?.storage]);

  useEffect(() => {
    let findedPack = packs.find((i) => i.id === selectedSample?.pack);

    if (findedPack) {
      setSelectedPack(findedPack);
    }
  }, [selectedSample, packs]);

  useEffect(() => {
    getSamplesT();
  }, []);

  useEffect(() => {
    const findedUnit = unitsList.find((i) => i.id === selectedSample?.unit);
    if (findedUnit) {
      setSelectedUnit(findedUnit);
    }
  }, [selectedSample, unitsList]);

  const getSamplesT = async () => {
    try {
      // Загружаем данные параллельно
      const [units, storages, typesData] = await Promise.all([
        getListUnits(),
        getStorages(false, ''),
        getTypeSamples(),
      ]);

      setUnitsList(units);
      setTreeLocation([
        ...storages,
        {
          id: undefined,
          type: 1,
          name: 'Глобальное хранилище',
          icon: 'icons/location-01.svg',
          color: '#ad1d1d',
          favorite: false,
          level: '0',
          parent: 0,
          nodes: [],
        },
      ]);
      setTypes(typesData);

      // Загружаем patient_description
      const descriptions = selectedSample?.patient_description ?? [];

      const result = await Promise.all(
        descriptions.map(async (item) => {
          const catalog = await getMappingCatalog(item.catalog);
          const fields = item.fields.map((field) => ({
            id: field.field,
            value: field.value,
            setting: field.setting,
            files: field.files ?? [],
          }));

          return { id: item.catalog, catalog, fields };
        }),
      );

      setPatientDescriptions(result);
    } catch (error) {
      console.error('Ошибка при загрузке данных в getSamplesT:', error);
    }
  };

  const getField = (field) => {
    if (field) {
      const elements = [];

      field?.catalog?.fields?.map((i) => {
        let item = field.fields?.find((j) => j.id === i.id);
        if (item) {
          if (Object.keys(item.setting).length > 0) {
            if (item.files?.length > 0) {
              if (i.type == 'file')
                elements.push(
                  <div className={style.info3 + ' ' + style.info_textCont}>
                    <div className={style.nameField}>{i.name}:</div>
                    <div className={style.userTextW}>
                      {item.files.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={style.fileContainer}
                            onClick={() => loadFile(item)}
                          >{` ${item.split('/').pop()}`}</div>
                        );
                      })}
                    </div>
                  </div>,
                );
              else if (i.type == 'image')
                elements.push(
                  <div className={style.info3 + ' ' + style.colorBlockCont}>
                    <div className={style.nameField}>{i.name}:</div>
                    <div>
                      {item.files?.map((item, index) => {
                        return (
                          <a
                            key={index}
                            target={'_blank'}
                            href={address_server_short + '' + item}
                            rel="noreferrer"
                          >
                            {item.split('/').reverse()[0]},
                          </a>
                        );
                      })}
                    </div>
                  </div>,
                );
            } else if (i.type == 'progress') {
              elements.push(
                <div className={style.info3 + ' ' + style.colorBlockCont}>
                  <div className={style.nameField}>{i.name}:</div>
                  <Progress
                    percent={parseFloat(item.value ?? 0)}
                    strokeColor={COLORS.color_brand}
                    strokeWidth={22}
                    showInfo={item.setting.percent}
                  />
                </div>,
              );
            } else if (i.type == 'select') {
              elements.push(
                <div className={style.info3 + ' ' + style.colorBlockCont}>
                  <div className={style.nameField}>{i.name}:</div>
                  <div className={style.userTextW}>{item.value}</div>
                </div>,
              );
            } else if (i.type == 'icon') {
              elements.push(
                <div className={style.info3 + ' ' + style.colorBlockCont}>
                  <div className={style.nameField}>{i.name}:</div>
                  <div>
                    <img
                      className={style.iconContainer}
                      src={address_server_short + PUBLIC_ASSETS + item?.setting?.file}
                    />
                  </div>
                </div>,
              );
            } else if (i.type == 'color') {
              elements.push(
                <div className={style.info3 + ' ' + style.colorBlockCont}>
                  <div className={style.nameField}>{i.name}:</div>
                  <div
                    className={style.colorBlock}
                    style={{ backgroundColor: `${item.value}` }}
                  ></div>
                </div>,
              );
            } else if (i.type == 'location') {
              elements.push(
                <div className={style.info_pacient_block2}>
                  <div className={style.info_pacient_text}>{i.name}</div>
                  <div className={style.info_pacient_text_right}>{item.value}</div>
                </div>,
              );
            } else {
              elements.push(
                <div className={style.info_pacient_block2}>
                  <div className={style.info_pacient_text}>{i.name}</div>
                  <div className={style.info_pacient_text_right}>
                    {item.setting.items ??
                      item.setting.name ??
                      item.setting.value ??
                      item.setting.result ??
                      moment(item.setting.date).format('YYYY-MM-DD') ??
                      item.setting.file ??
                      item.setting.address ??
                      moment(item.setting.from).format('YYYY-MM-DD')}
                    {item.setting.to && ' - ' + moment(item.setting.to).format('YYYY-MM-DD')}
                  </div>
                </div>,
              );
            }
          } else if (i.type == 'yes_no') {
            elements.push(
              <div className={style.info3 + ' ' + style.colorBlockCont}>
                <div className={style.nameField}>{i.name}:</div>
                <div className={style.userTextW}>{item.value == 'yes' ? 'Да' : 'Нет'}</div>
              </div>,
            );
          } else {
            elements.push(
              <div className={style.info_pacient_block2}>
                <div className={style.info_pacient_text}>{i.name}</div>
                <div>{item.value}</div>
              </div>,
            );
          }
        } else {
          elements.push(
            <div className={style.info_pacient_block2}>
              <div className={style.info_pacient_text}>{i.name}</div>
            </div>,
          );
        }
      });
      return elements;
    }
    return <>1</>;
  };

  const barcodesRef = useRef(null);

  const handlePrint = () => {
    if (selectedSample.barcodes.length !== 0) {
      setPrintItems([
        ...selectedSample.barcodes.map((val) => {
          return { barcode: val.value };
        }),
      ]);
      setIsOpenPrintModal(true);
    } else {
      showAlert('У образца отсутствует штрихкод!', 'warning');
    }
  };

  const onClose = () => {
    modalStore.closeModal('sampleView');
    clearSelectedSample();
  };

  const onLoadSample = async () => {
    await storeContext.loadSampleById(selectedSample.id);
  };

  const onEdit = async () => {
    await onLoadSample();
    modalStore.openModal('sampleEdit', { mode, storeContext }, true);
  };

  const onDelete = async () => {
    const deleteItem = async () => {
      let res = await deleteSample(selectedSample.id);
      if (res.success) {
        deleteSampleInPackById(selectedSample.pack, selectedSample.id);
        await loadTree(false, '');
        clearSelectedSample();
      } else {
        showAlert('Возникла ошибка при попытке удалить образец!', 'error');
      }
    };
    showAlert('Вы действительно хотите удалить образец?', 'sure', deleteItem);
  };

  const parseValue = (val) => {
    try {
      return JSON.parse(val);
    } catch {
      return val;
    }
  };

  const loadFile = (file) => {
    const fileExtension = file.split('/').pop();
    const loadFileBD = async () => {
      const res = await getFileSample(file);
      const data = new Blob([res]);
      FileSaver.saveAs(data, fileExtension);
    };
    loadFileBD();
  };

  const restoreSamples = () => {
    setRestoreModal(true);
  };

  const openHistory = () => {
    setHistoryModal(true);
  };

  const createChild = () => {
    if (selectedEmptyCellForCopy?.length > 0) setCreateChildrenModal(true);
    else showAlert('Не выбраны ячейки для создания', 'info');
  };

  const showParent = () => {
    setSelectedTreeSample(selectedSample?.id);
    setTreeParentModal(true);
  };

  const showSampleSourceModal = async (id) => {
    // setSelectedTreeSample(selectedSample?.id)
    await sampleSourceStore.setSampleSourceId(id);
    const { result } = await getTypeSampleSourcesList();
    setTypesSampleSource(result.data);
    setSampleSourceModal(true);
  };

  return (
    <>
      <div
        className={classNames({
          [style.addMenu_notBack]: mode.path === 'Хранилище',
          [style.addMenu]: mode.path !== 'Хранилище',
        })}
      >
        <div className={style.addMenu_block} ref={blockRef}>
          <div className={style.title}>
            <div>{mode.path}</div>
            <button onClick={onClose} className={style.closeButton}>
              <img src={closeSVG} alt="" />
            </button>
          </div>
          <div className={style.block1}>
            <div className={style.block1_text}></div>
            <div
              className={classNames(style.block1_items, {
                [style.block1_items_virtual]: selectedSample?.is_virtual,
                [style.block1_items_left]: selectedSample?.status != 'packed',
              })}
            >
              {!selectedSample?.is_virtual && selectedSample?.status == 'packed' ? (
                <div className={'hover_hint_parent' + ' ' + style.block1_button_outContainer}>
                  <img
                    src={outSVG}
                    className={style.block1_button_out}
                    onClick={() => setDefreezeModal({ show: true, type: 'out' })}
                  ></img>
                  <div className={'hover_hint'}>Достать из хранилища</div>
                </div>
              ) : (
                !selectedSample?.is_virtual &&
                selectedSample?.status == 'extracted' && (
                  <div className={'hover_hint_parent' + ' ' + style.block1_button_outContainer}>
                    <img
                      src={intoSVG}
                      className={style.block1_button_out}
                      onClick={() => setDefreezeModal({ show: true, type: 'into' })}
                    ></img>
                    <div className={'hover_hint'}>Вернуть в хранилище</div>
                  </div>
                )
              )}
              {!selectedSample?.is_virtual && selectedSample?.status == 'packed' && (
                <div className={'hover_hint_parent' + ' ' + style.block1_button_outContainer}>
                  <img
                    src={notification}
                    className={style.block1_button_child}
                    onClick={() => setNotificationModal(true)}
                  ></img>
                  <div className={'hover_hint'}>Установить уведомления</div>
                </div>
              )}
              {selectedSample?.status == 'packed' && mode.path == 'Хранилище' && (
                <div className={'hover_hint_parent' + ' ' + style.block1_button_childContainer}>
                  <img
                    src={children}
                    className={style.block1_button_child}
                    onClick={createChild}
                  ></img>
                  <div className={'hover_hint'}>Создать производные</div>
                </div>
              )}

              <div className={'hover_hint_parent'}>
                <div
                  className={
                    style.block1_button +
                    ' ' +
                    style.block1_button_print +
                    ' ' +
                    (!selectedSample?.is_virtual && selectedSample?.status != 'packed'
                      ? style.block1_button_print_margin
                      : '')
                  }
                  onClick={handlePrint}
                ></div>
                <div className={'hover_hint'}>Печать</div>
              </div>

              {!selectedSample?.is_virtual &&
                rules?.sample?.move &&
                selectedSample?.status == 'packed' && (
                  <div className={'hover_hint_parent'}>
                    <div
                      className={style.block1_button + ' ' + style.block1_button_move}
                      onClick={() => {
                        if (
                          mode.path === 'Образцы' ||
                          mode.path === 'Архив' ||
                          mode.path === 'Все образцы'
                        ) {
                          mode.setCopyMode(true);
                          mode.setCopyType(ModeMove);
                        } else {
                          setModalMove(true);
                          setModalMoveMode(ModeMove);
                        }
                      }}
                    ></div>

                    <div className={'hover_hint'}>Переместить образец</div>
                  </div>
                )}

              {rules?.sample?.upsert && selectedSample?.status == 'packed' && (
                <div className={'hover_hint_parent'}>
                  <div
                    className={style.block1_button + ' ' + style.block1_button_edit}
                    onClick={onEdit}
                  ></div>
                  <div className={'hover_hint'}>Изменить</div>
                </div>
              )}
              {!selectedSample?.is_virtual &&
                rules?.sample?.move &&
                selectedSample?.status == 'packed' && (
                  <div className={'hover_hint_parent'}>
                    <div
                      className={style.block1_button + ' ' + style.block1_button_copy}
                      onClick={() => {
                        if (
                          mode.path === 'Образцы' ||
                          mode.path === 'Архив' ||
                          mode.path === 'Все образцы'
                        ) {
                          mode.setCopyMode(true);
                          mode.setCopyType(ModeCopy);
                        } else {
                          setModalMove(true);
                          setModalMoveMode(ModeCopy);
                        }
                      }}
                    ></div>
                    <div className={'hover_hint hover_hint_right'}>Разделить образец</div>
                  </div>
                )}
              {!selectedSample?.is_virtual &&
                rules?.sample?.delete &&
                selectedSample?.status == 'packed' && (
                  <div className={'hover_hint_parent'}>
                    <div
                      className={style.block1_button + ' ' + style.block1_button_delete}
                      onClick={onDelete}
                    ></div>
                    <div className={'hover_hint hover_hint_right'}>Удалить образец</div>
                  </div>
                )}
            </div>
          </div>
          {selectedSample?.status == 'extracted' && (
            <div className={style.blockDefreeze}>
              <div className={style.blockDefreezeText}>Образец извлечен</div>
            </div>
          )}
          {selectedSample?.status == 'archived' && !selectedSample?.is_virtual && (
            <div className={style.blockDefreeze}>
              <div className={style.blockDefreezeButton} onClick={restoreSamples}>
                Вернуть в хранилище
              </div>
            </div>
          )}

          <div className={style.block1}>
            <div className={style.block1_text}>Описание образца</div>
          </div>
          <div className={style.block1}>
            <div className={style.block1_text}>ID образца: {selectedSample?.id_general}</div>
          </div>
          <div className={style.block2}>
            <div className={style.icon}>
              {selectedType?.icon && (
                <img
                  className={style.iconType}
                  src={`${address_server_short}${PUBLIC_ASSETS}${selectedType?.icon}`}
                />
              )}
            </div>
            <div className={style.number}>
              {selectedSample?.name == null ||
              selectedSample?.name == 'null' ||
              selectedSample?.name == undefined
                ? ''
                : selectedSample?.name}
            </div>
          </div>
          <div>
            <div className={style.info_text}>Тип образца: {selectedType?.name ?? ''}</div>
            <div className={style.info_text}>Расположение: {path}</div>
            <div className={style.info_text}>Штатив: {selectedPack?.name ?? ''}</div>
            <div className={style.info_text}>
              Позиция: {selectedSample?.line}/{selectedSample?.column}
            </div>
            <div className={style.block_barcode} ref={barcodesRef}>
              {selectedSample?.barcodes?.map((barcode) => (
                <div key={barcode.id}>
                  <div className={style.block_barcode_text}>{barcode.value}</div>
                  <Barcode
                    displayValue={false}
                    value={barcode.value}
                    height={30}
                    background={'#DCE6E9'}
                  />
                </div>
              ))}
            </div>
            <div className={style.info2_text}>
              Количество образца: {selectedSample?.volume} {selectedUnit?.code}
            </div>
            {selectedSample?.aliquot_info && (
              <>
                <div className={style.info2_text}>
                  Количество аликвот: {selectedSample?.aliquot_info?.total}
                </div>
                <div className={style.info2_text}>
                  Общее количество образца: {selectedSample?.aliquot_info?.volume}{' '}
                  {selectedUnit?.code}
                </div>
              </>
            )}

            <div style={{ margin: '25px 0' }} className={style.info2_text}>
              Исходный образец:{' '}
              <p
                style={{
                  display: 'inline-block',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'blue',
                }}
                onClick={() => showParent()}
              >
                ID{' '}
                {selectedSample?.id_parent == null
                  ? selectedSample?.id_general
                  : selectedSample?.id_parent}
              </p>
            </div>

            <div className={style.info3}>
              <div className={style.info3_text}>Дата забора: {selectedSample?.date}</div>
              <div className={style.info3_text}>Изменен: {selectedSample?.date_update}</div>
              <div className={style.info3_text}>
                Срок годности:{' '}
                {selectedSample?.expire_date ? selectedSample?.expire_date : 'Не указано'}
              </div>
            </div>

            <button className={style.history} onClick={openHistory}>
              История изменений
            </button>
            <div style={{ margin: '25px 0' }} className={style.info2_text}>
              Описание: {selectedSample?.description}
            </div>
            <div style={{ margin: '25px 0' }} className={style.info2_text}>
              Разморозок осталось:{' '}
              {selectedSample?.defreeze != null && selectedSample?.defreeze != undefined
                ? selectedSample?.defreeze
                : 'Не указано'}
            </div>
            <div style={{ margin: '25px 0' }} className={style.info2_text}>
              Разморозок выполнено:{' '}
              {selectedSample?.defreeze_done != null && selectedSample?.defreeze_done != undefined
                ? selectedSample?.defreeze_done
                : '0'}
            </div>
            <div style={{ margin: '25px 0' }} className={style.info2_text}>
              Источник:{' '}
              {selectedSample?.sample_source != null &&
              selectedSample?.sample_source != undefined ? (
                <p
                  style={{
                    display: 'inline-block',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: 'blue',
                  }}
                  onClick={() => showSampleSourceModal(selectedSample?.sample_source?.id)}
                >
                  {selectedSample?.sample_source?.name}
                </p>
              ) : (
                'Не указано'
              )}
            </div>
            {selectedSample?.user_fields && selectedSample?.user_fields?.length > 0 && (
              <div className={style.separatingRow}>Пользовательские поля</div>
            )}

            <div className={style.userFieldContainer}>
              {selectedSample?.user_fields &&
                selectedSample?.user_fields?.map((val) => {
                  if (val.type.type_name == 'finance')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>
                          {parseValue(val.value).value
                            ? parseValue(val.value).value +
                              ' ' +
                              parseValue(val.value).setting.postfix
                            : ''}
                        </div>
                      </div>
                    );
                  if (val.type.type_name == 'color')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div
                          className={style.colorBlock}
                          style={{ backgroundColor: `${parseValue(val.value).value}` }}
                        ></div>
                      </div>
                    );
                  else if (val.type.type_name == 'select_check')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        {parseValue(val.value).setting?.items !== '' ? (
                          <div className={style.userTextW}>
                            {parseValue(val.value).setting?.items?.replace(',', ', ')}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    );
                  else if (val.type.type_name == 'switch')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <SwitchWidget
                          disabled={true}
                          selected={parseValue(val.value).value}
                          onChange={() => {}}
                        />
                      </div>
                    );
                  else if (val.type.type_name == 'float' || val.type.type_name == 'integer')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>
                          {(parseValue(val.value).value == undefined
                            ? ''
                            : parseValue(val.value).value) +
                            ' ' +
                            (unitsList?.find((value) => value.id == parseValue(val.setting)?.unit)
                              ?.name == undefined
                              ? ''
                              : unitsList?.find(
                                  (value) => value.id == parseValue(val.setting)?.unit,
                                )?.name)}
                        </div>
                      </div>
                    );
                  else if (val.type.type_name == 'icon')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div>
                          <img
                            className={style.iconContainer}
                            src={
                              address_server_short +
                              PUBLIC_ASSETS +
                              parseValue(val.value)?.setting?.file
                            }
                          />
                        </div>
                      </div>
                    );
                  else if (val.type.type_name == 'image')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div>
                          {parseValue(val.value) &&
                            parseValue(val.value)?.map((item) => {
                              return (
                                <a
                                  target={'_blank'}
                                  href={address_server_short + '' + item}
                                  rel="noreferrer"
                                >
                                  {item.split('/')[2]},
                                </a>
                              );
                            })}
                        </div>
                      </div>
                    );
                  else if (val.type.type_name == 'yes_no')
                    return (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>
                          {parseValue(val.value).value == 'yes' ? 'Да' : 'Нет'}
                        </div>
                      </div>
                    );
                  else if (val.type.type_name == 'progress')
                    return parseValue(val.value).setting?.value !== '' ? (
                      <div className={style.info3 + ' ' + style.colorBlockCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <Progress
                          percent={parseFloat(parseValue(val.value).value ?? 0)}
                          strokeColor={
                            parseValue(val.setting)?.find((val) => val.param == 'color')?.color ??
                            COLORS.color_brand
                          }
                          strokeWidth={22}
                          showInfo={
                            parseValue(val.setting)?.find((val) => val.param == 'percentVisible')
                              ?.value || false
                          }
                        />
                      </div>
                    ) : (
                      ''
                    );
                  else if (val.value && val.type.type_name == 'file')
                    return (
                      <div className={style.info3 + ' ' + style.info_textCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>
                          {parseValue(val.value) &&
                            parseValue(val.value).map((item, index) => {
                              if (index != JSON.parse(JSON.stringify(val.value)).length - 1)
                                return (
                                  <div
                                    className={style.fileContainer}
                                    onClick={() => loadFile(item)}
                                  >{` ${item.split('/').pop()}, `}</div>
                                );
                              else
                                return (
                                  <div
                                    className={style.fileContainer}
                                    onClick={() => loadFile(item)}
                                  >{` ${item.split('/').pop()}`}</div>
                                );
                            })}
                        </div>
                      </div>
                    );
                  else if (val.value && val.type.type_name == 'barcode')
                    return (
                      <div className={style.info3 + ' ' + style.info_textCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>
                          {parseValue(val.value).setting?.barcode}{' '}
                          {parseValue(val.value).setting?.value}
                        </div>
                      </div>
                    );
                  else if (val.value || val.value == '')
                    return (
                      <div className={style.info3 + ' ' + style.info_textCont}>
                        <div className={style.nameField}>{val.name}:</div>
                        <div className={style.userTextW}>{parseValue(val.value).value}</div>
                      </div>
                    );
                })}
            </div>
            {patientDescriptions.length > 0 && (
              <>
                <div className={style.separatingRow}>Дополнительная информация</div>
                <div className={style.info_pacient_block}>
                  {patientDescriptions.map((i) => (
                    <>{getField(i).map((j) => j)}</>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {modalMove && (
        <ModalMoveComponent
          openModal={modalMove}
          mode={modalMoveMode}
          onClose={() => {
            setModalMove(false);
          }}
          action={async (data) => {
            if (!data.pack || (data.line && data.column)) {
              let res = await moveSample(data.id, {
                id: data.id,
                volume: data.volume,
                new_storage: data.storage,
                new_pack: data.pack,
                column: data.column,
                line: data.line,
              });
              if (!res.success) {
                if (res.error_code === 2016) {
                  showAlert(
                    'Данная ячейка уже занята. Поместите образец в другое место хранения',
                    'error',
                  );
                } else {
                  showAlert(res.error_code, 'error');
                }
              } else {
                setModalMove(false);
                mode.setVisibleView(false);
                await loadTree(false, '');
                await updateSelectedTreeNodePacks();
                clearSelectedSample();
                showAlert('Образец успешно перемещен', 'success');
              }
            } else {
              showAlert('Для штатива не выбрано место хранения!', 'error');
            }
          }}
        />
      )}
      {isOpenPrintModal && (
        <PrintSizeModal
          items={printItems}
          setModalOpened={setIsOpenPrintModal}
          mode={mode}
        ></PrintSizeModal>
      )}
      {defreezeModal.show && (
        <ModalDefreeze
          mode={mode}
          sampleIds={[selectedSample.id]}
          defreeze={defreezeModal}
          selectedSampleId={selectedSample.id}
          setDefreeze={setDefreezeModal}
        />
      )}
      {restoreModal && (
        <ModalRestoreSample
          sample={selectedSample}
          mode={mode}
          setClose={setRestoreModal}
        ></ModalRestoreSample>
      )}
      {historyModal && (
        <ModalHistory sample={selectedSample} mode={mode} setClose={setHistoryModal}></ModalHistory>
      )}
      {createChildrenModal && (
        <ModalCreateChildren
          mode={mode}
          sampleId={selectedSample.id}
          selectedTypeId={selectedSample.type}
          setClose={setCreateChildrenModal}
        ></ModalCreateChildren>
      )}
      {treeParentModal && (
        <ModalTreeParent
          mode={mode}
          setClose={setTreeParentModal}
          sampleId={selectedSample.id}
        ></ModalTreeParent>
      )}
      {notificationModal && (
        <ModalSetNotification
          mode={mode}
          setClose={setNotificationModal}
          sampleId={selectedSample.id_general}
        ></ModalSetNotification>
      )}
      {sampleSourceModal && (
        <AddSampleSourceModal
          setModalOpened={setSampleSourceModal}
          mode={mode}
          typesSampleSource={typesSampleSource}
          isAddSuccess={isEditSampleSourceSuccess}
          setIsAddSuccess={setIsEditSampleSourceSuccess}
          disabled={true}
        />
      )}
    </>
  );
};

export default ModalSampleView;
